import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';

const radioCardContentContainerBase = css`
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: ${theme.spacing(1)};
  pointer-events: none;
`;

const radioCardContentContainerInteractive = css`
  pointer-events: auto;
`;

const radioCardContentBase = css`
  display: flex;
  flex-direction: column;
  align-items: start;
  text-align: start;
  gap: ${theme.spacing(0.5)};
  pointer-events: none;
  width: 100%;
`;

const radioCardContentInteractive = css`
  pointer-events: auto;
`;

export const RadioCardStyles = {
  radioCardField: css`
    display: flex;
    min-height: 52px;
    gap: ${theme.spacing(2)};
  `,
  radioCard: css`
    padding: ${theme.spacing(2)};
    gap: ${theme.spacing(1)};
    display: flex;
    flex: 1;
    position: relative;
    border-radius: ${theme.borderRadius.medium};
    border: 1px solid;
    border-color: ${theme.colors.neutral40};
    color: ${theme.colors.primary50};
    transition: color 250ms ease-out, border-color 250ms ease-out;
    background-color: ${theme.colors.white};

    &[aria-checked='true'] {
      border-color: ${theme.colors.primary50};
    }
    &:hover {
      background-color: ${theme.colors.neutral5};
    }
    &:focus {
      border-color: ${theme.colors.primary50};
      outline-color: ${theme.colors.primary50};
      outline-offset: 4px;
    }
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `,
  radioCardContentContainer: (interactiveOption = false) =>
    cx(radioCardContentContainerBase, interactiveOption && radioCardContentContainerInteractive),
  radioCardContent: (isInteractive = false) => cx(radioCardContentBase, isInteractive && radioCardContentInteractive),
  radioCheckbox: css`
    width: 20px;
    height: 20px;
    pointer-events: none;
  `,
  radioIcon: css`
    align-self: center;
    width: ${theme.spacing(5)};
  `,
  radioDescription: css`
    width: 100%;
  `,
};
